import { render, staticRenderFns } from "./submenu-tabs.vue?vue&type=template&id=52ad048a&scoped=true"
import script from "./submenu-tabs.vue?vue&type=script&lang=js"
export * from "./submenu-tabs.vue?vue&type=script&lang=js"
import style0 from "./submenu-tabs.vue?vue&type=style&index=0&id=52ad048a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ad048a",
  null
  
)

export default component.exports